export default __webpack_public_path__ + "static/media/h_blog1.b6ce501d.jpg";